export enum ExpertAdviceType {
  PRECISION = 'precision',
  PARCEL = 'parcel'
}
